var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2 66.7C23.6 66.7 15.9 66.1 15.5 66.1C15 66.1 14.3 66.3 14.3 67.4C14.3 68.5 14.4 70 14.6 71.4C15.3 76.2 24.4 75.6 25 74.4L24.2 66.7Z",
    fill: "#FF931E",
    stroke: "#FF931E",
    strokeWidth: 1.0559,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 8.70001H24.8C23.7 8.70001 22.8 9.60001 22.8 10.7C22.8 10.7 22.7 63.7 22.7 64.2C22.6 66.5 22.4 68.9 21.9 71.2C21.4 73.3 17.2 74.2 14.6 71.6C14.9 73.7 14.2 75.8 24.1 75.9H51.8H72C73.1 75.9 74 75 74 73.9V53.7V10.7C73.9 9.60001 73 8.70001 72 8.70001Z",
    fill: "#5A87FF",
    stroke: "#5A87FF",
    strokeWidth: 1.0559,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9 26.8C48.9 22 45 18.2 40.3 18.2C35.6 18.2 31.7 22.1 31.7 26.8C31.7 30 33.5 32.8 36.1 34.3V43.8C36.1 44.5 36.9 44.9 37.3 44.3L39.8 40.9C40.1 40.5 40.5 40.5 40.8 40.9L43.3 44.3C43.7 44.9 44.5 44.5 44.5 43.8V34.3C47.1 32.8 48.9 30 48.9 26.8Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 1.0559,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9 23.5C44 24.3 39.8 29.3 39.8 29.3C39.8 29.3 36.8 26.6 36.4 26.2",
    stroke: "#101C1E",
    strokeWidth: 1.5838,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9 47.3C67.4 47.3 62.1 49.1001 62.1 51.4001V79.4001C62.1 81.7001 67.4 83.5 73.9 83.5C80.4 83.5 85.7 81.7001 85.7 79.4001V51.4001C85.7 49.1001 80.4 47.3 73.9 47.3Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 1.0559,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7 51.4C85.8 53.8 82.5 55 80.7 55.6C75.3 57.1 66.9 57.2 62.7 53C62.3 52.5 62 51.9 62.2 51.4C62.3 52 62.7 52.3 63.1 52.6C66.2 55 84.3 55.6 85.7 51.4Z",
    fill: "#FF931E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7 58.5C85.8 60.9 82.5 62.1 80.7 62.7C75.3 64.2 66.9 64.3 62.7 60.1C62.3 59.6 62 59 62.2 58.5C62.3 59.1 62.7 59.4 63.1 59.7C66.2 62.1 84.3 62.7 85.7 58.5Z",
    fill: "#FF931E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7 65.6001C85.8 68.0001 82.5 69.2001 80.7 69.8001C75.3 71.3001 66.9 71.4001 62.7 67.2001C62.3 66.7001 62 66.1001 62.2 65.6001C62.3 66.2001 62.7 66.5001 63.1 66.8001C66.2 69.2001 84.3 69.8001 85.7 65.6001Z",
    fill: "#FF931E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7 72.7001C85.8 75.1001 82.5 76.3001 80.7 76.9001C75.3 78.4001 66.9 78.5001 62.7 74.3001C62.3 73.8001 62 73.2001 62.2 72.7001C62.3 73.3001 62.7 73.6001 63.1 73.9001C66.2 76.3001 84.3 76.9001 85.7 72.7001Z",
    fill: "#FF931E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7 79.8C85.8 82.2 82.5 83.4 80.7 84C75.3 85.5 66.9 85.6 62.7 81.4C62.3 80.9 62 80.3 62.2 79.8C62.3 80.4 62.7 80.7 63.1 81C66.2 83.4 84.3 84 85.7 79.8Z",
    fill: "#FF931E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2 68.8C47.7 68.8 42.4 70.6 42.4 72.9V87.1C42.4 89.4 47.7 91.2 54.2 91.2C60.7 91.2 66 89.4 66 87.2V72.9C66 70.7 60.8 68.8 54.2 68.8Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 1.0559,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72.9C66.1 75.3 62.8 76.5 61 77.1C55.6 78.6 47.2 78.7 43 74.5C42.6 74 42.3 73.4 42.5 72.9C42.6 73.5 43 73.8 43.4 74.1C46.5 76.5 64.6 77.1 66 72.9Z",
    fill: "#FF931E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66 80.1001C66.1 82.5001 62.8 83.7001 61 84.3001C55.6 85.8001 47.2 85.9001 43 81.7001C42.6 81.2001 42.3 80.6001 42.5 80.1001C42.6 80.7001 43 81.0001 43.4 81.3001C46.5 83.6001 64.6 84.3001 66 80.1001Z",
    fill: "#FF931E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66 87.2001C66.1 89.6001 62.8 90.8001 61 91.4001C55.6 92.9001 47.2 93.0001 43 88.8001C42.6 88.3001 42.3 87.7001 42.5 87.2001C42.6 87.8001 43 88.1001 43.4 88.4001C46.5 90.7001 64.6 91.4001 66 87.2001Z",
    fill: "#FF931E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarted);
export default __webpack_public_path__ + "static/media/started.d994d784135299c18b90714d11839840.svg";
export { ForwardRef as ReactComponent };